import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { EligibilityControllerApi } from "../../services";
import {
  getConfigObject,
  getPageIndexWhileSearch,
  getPageSize,
  useBaseContent,
} from "../../utils/utils";
import { DGT_Pagination } from "../../utils/utils";
import { GridSortItem } from "@mui/x-data-grid";
import { useRef } from "react";
interface UseGetAllEligibilityByPatientIDProps {
  patientId?: string;
  xTENANTID?: string;
  pagination: DGT_Pagination;
  gridSorting?: GridSortItem[];
  enabled?: boolean
}

/**
 *
 * @author Atish Bagate
 */
export function useGetAllEligibilityByPatientID({
  patientId,
  xTENANTID,
  pagination,
  enabled = true
}: UseGetAllEligibilityByPatientIDProps): useBaseContent<any> {
  const prevPage = useRef<number>(pagination.page);

  const pageIndex = getPageIndexWhileSearch({
    pagination,
    prevPage,
  });
  const pageSize = getPageSize("", pagination);
  return useQuery({
    queryKey: [
      "get-all-eligibility-by-patient-id",
      patientId,
      pageIndex,
      pageSize,
      xTENANTID,
    ],
    enabled: enabled && !!patientId && !!xTENANTID,
    refetchOnWindowFocus: false,


    placeholderData: keepPreviousData,
    queryFn: async () =>
      new EligibilityControllerApi(getConfigObject())
        .getAllEligibilities(
          patientId!,
          pageIndex, //page
          pageSize,
          xTENANTID // xTENANTID
        )
        .then((res) => res?.data),
  });
}
